import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { updateConsultee } from '../methods';
import { UpdateConsulteeRequest } from '../types';

export const useUpdateConsultee = (): UseMutationResult<
  unknown,
  unknown,
  UpdateConsulteeRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(updateConsultee, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageTeamConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getTQAdmins] });
    },
  });
};
